/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPackagePresignedUploadUrl
 */
export interface DataPackagePresignedUploadUrl {
    /**
     * 
     * @type {string}
     * @memberof DataPackagePresignedUploadUrl
     */
    uploadUrl: string;
}

/**
 * Check if a given object implements the DataPackagePresignedUploadUrl interface.
 */
export function instanceOfDataPackagePresignedUploadUrl(value: object): value is DataPackagePresignedUploadUrl {
    if ((!('uploadUrl' in (value as Record<string, any>)) && !('upload_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadUrl'] === undefined && (value as Record<string, any>)['upload_url'] === undefined)) return false;
    return true;
}

export function DataPackagePresignedUploadUrlFromJSON(json: any): DataPackagePresignedUploadUrl {
    return DataPackagePresignedUploadUrlFromJSONTyped(json, false);
}

export function DataPackagePresignedUploadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPackagePresignedUploadUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadUrl': json['upload_url'],
    };
}

export function DataPackagePresignedUploadUrlToJSON(json: any): DataPackagePresignedUploadUrl {
    return DataPackagePresignedUploadUrlToJSONTyped(json, false);
}

export function DataPackagePresignedUploadUrlToJSONTyped(value?: DataPackagePresignedUploadUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'upload_url': value['uploadUrl'],
    };
}

